module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('header', [_c('router-link', {
    attrs: {
      "to": "../overview"
    }
  }, [_vm._v("‹ overview")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.player.name))]), _c('a', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("next ›")])]), _vm._v(" "), _c('main', [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.player.rounds), function(round) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (round.blitz),
        expression: "round.blitz"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": _vm._s(round.blitz)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          round.blitz = _vm._n($event.target.value)
        }, _vm.save],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("minusBlitz")(round)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (round.dutch),
        expression: "round.dutch"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": _vm._s(round.dutch)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          round.dutch = _vm._n($event.target.value)
        }, _vm.save],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("roundTotal")(round)))])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], true)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('tr', [_c('th', [_vm._v("Blitz")]), _c('th', [_vm._v("* -2")]), _c('th', [_vm._v("Dutch")]), _c('th', [_vm._v("Total")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-729e9b7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/PlayerDetails.vue
// module id = 93
// module chunks = 2